import Constant from '@/const';
import axios from 'axios';

const getInstallation = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/installation'),
    );
    return response.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getInstallation;
